export const subjectOptions: string[] = [
  'Logging in to my account',
  'Complete my profile',
  'Classroom',
  'Business',
  'Training',
  'Other',
];
